export const NutritionInformation = {
  bindings: {
    data: '<',
    serves: '<',
  },

  template: `
    <div class="nutrition-information card bg-gray-100 p-3">
      <h5>Nutritional Information</h5>
      <div class="pill-toggle d-flex w-100 mt-2">
        <button class="btn btn-sm btn-pill w-100"
          type="button"
          ng-class="{ 'btn-primary text-white': $ctrl.mode == 'per_serve' }"
          ng-click="$ctrl.mode = 'per_serve'">
          Per Serve<span ng-show="$ctrl.serves">*</span>
        </button>
        <button class="btn btn-sm btn-pill w-100"
          type="button"
          ng-class="{ 'btn-primary': $ctrl.mode == 'per_grams' }"
          ng-click="$ctrl.mode = 'per_grams'">
          Per 100g
        </button>
      </div>
      <table class="table table-sm">
        <tr>
          <td class="border-top-0"><strong>Calories</strong></td>
          <td class="border-top-0 text-right">
            <strong ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.calculatedCalories, $ctrl.serves) | number:1 }} Cal</strong>
            <strong ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.calculatedCalories, $ctrl.data.calculatedWeight) | number:1 }} Cal</strong>
          </td>
        </tr>
        <tr>
          <td>Protein</td>
          <td class="text-right">
            <span ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.proteinInG, $ctrl.serves) | number:1 }}g</span>
            <span ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.proteinInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>
          </td>
        </tr>
        <tr>
          <td>Fat Total</td>
          <td class="text-right">
            <span ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.fatTotalInG, $ctrl.serves) | number:1 }}g</span>
            <span ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.fatTotalInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>
          </td>
        </tr>
        <tr>
          <td>Fat Saturated</td>
          <td class="text-right">
            <span ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.fatSaturatedInG, $ctrl.serves) | number:1 }}g</span>
            <span ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.fatSaturatedInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>
          </td>
        </tr>
        <tr>
          <td>Carbohydrates</td>
          <td class="text-right">
            <span ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.carbohydratesInG, $ctrl.serves) | number:1 }}g</span>
            <span ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.carbohydratesInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>
          </td>
        </tr>
        <tr>
          <td>Sugars</td>
          <td class="text-right">
            <span ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.sugarsInG, $ctrl.serves) | number:1 }}g</span>
            <span ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.sugarsInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>
          </td>
        </tr>
        <tr>
          <td>Sodium</td>
          <td class="text-right">
            <span ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.sodiumInMg, $ctrl.serves) | number:1 }}mg</span>
            <span ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.sodiumInMg, $ctrl.data.calculatedWeight) | number:1 }}mg</span>
          </td>
        </tr>
        <tr ng-="$ctrl.data.fibreInG > 0">
          <td>Dietary Fibre</td>
          <td class="text-right">
            <span ng-if="$ctrl.mode == 'per_serve'">{{ $ctrl.calculatePerServe($ctrl.data.fibreInG, $ctrl.serves) | number:1 }}g</span>
            <span ng-if="$ctrl.mode == 'per_grams'">{{ $ctrl.calculatePerGrams($ctrl.data.fibreInG, $ctrl.data.calculatedWeight) | number:1 }}g</span>
          </td>
        </tr>
        <tr ng-show="$ctrl.serves" class="text-right">
          <td colspan="2">
            * This recipe has
            <strong ng-pluralize count="$ctrl.serves" when="{'one': '1 serve.', 'other': '{} serves'}"></strong>.
          </td>
        </tr>
        <tr ng-show="$ctrl.data['highProtein?']">
          <td colspan="2">
            <a href="#" ng-click="show_protein = !show_protein">
              High in Protein
              <span class="float-right">
                <i class="fa" ng-class="{ 'fa-angle-up': show_protein, 'fa-angle-down': !show_protein }"></i>
              </span>
            </a>
            <div
              class="mt-2"
              ng-show="show_protein">
              <div class="details">
                <p><em>Protein is used by the body to build, grown, repair and maintain every part of your body.</em></p>
                <p>When we start exercising our body requires extra protein to help repair the muscle damage we cause (this is good damage!) and to grow new muscle. Ladies you need 45-60g protein per day. Blokes, you need more, approximately 65-80g per day. </p>
                <p>Muscle is like an engine, it burns through energy (Calories) - so the more muscle we have the more energy we burn. Stock up on high protein meals (15g protein per serve) and snacks (5g protein per serve) after a hard training session.</p>
                <p>Protein also helps keep you feeling fuller for longer, so try to include some in every meal.</p>
                <p><button ng-click="show_protein=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>
              </div>
            </div>
          </td>
        </tr>
        <tr ng-show="$ctrl.data['highCarb?']">
          <td colspan="2">
            <a href="#" ng-click="show_carbs = !show_carbs">
              High in Carbohydrates
              <span class="float-right">
                <i class="fa" ng-class="{ 'fa-angle-up': show_carbs, 'fa-angle-down': !show_carbs }"></i>
              </span>
            </a>
            <div
              class="mt-2"
              ng-show="show_carbs">
              <div class="details">
                <p><em>Carbohydrates are the primary source of energy for your body.</em></p>
                <p>Our body needs carbohydrate for brain function, red blood cell health and to burn fat! Carbohydrates are found in breads & cereals, rice, pasta, starchy veggies such as potato, fruit & dairy foods.</p>
                <p>When choosing foods that contain carbohydrates consider the ingredients. For example, if a breakfast cereal contains dried fruit, it should have a slightly higher sugar level that one that does not. Choose grainy breads- the more grains you can see the better and look for Low GI (Glycemic Index) foods as these will provide you longer lasting energy and will help keep you feeling fuller for longer. Note not all foods have been tested nor display their Glycemic Index.</p>
                <p>A high carb meal contains at least 70g carbs per serve and a high carb snack, 20g or more. For those looking for a low carb option, a low carb meal contains 40g or less carbs per serve and a snack contains 15g or less carbs per serve.</p>
                <p><button ng-click="show_carbs=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>
              </div>
            </div>
          </td>
        </tr>
        <tr ng-show="$ctrl.data['lowCarb?']">
          <td colspan="2">
            <a href="#" ng-click="show_carbs = !show_carbs">
              Low in Carbohydrates
              <span class="float-right">
                <i class="fa" ng-class="{ 'fa-angle-up': show_carbs, 'fa-angle-down': !show_carbs }"></i>
              </span>
            </a>
            <div
              class="mt-2"
              ng-show="show_carbs">
              <div class="details">
                <p><em>Carbohydrates are the primary source of energy for your body.</em></p>
                <p>Our body needs carbohydrate for brain function, red blood cell health and to burn fat! Carbohydrates are found in breads & cereals, rice, pasta, starchy veggies such as potato, fruit & dairy foods.</p>
                <p>When choosing foods that contain carbohydrates consider the ingredients. For example, if a breakfast cereal contains dried fruit, it should have a slightly higher sugar level that one that does not. Choose grainy breads- the more grains you can see the better and look for Low GI (Glycemic Index) foods as these will provide you longer lasting energy and will help keep you feeling fuller for longer. Note not all foods have been tested nor display their Glycemic Index.</p>
                <p>A high carb meal contains at least 70g carbs per serve and a high carb snack, 20g or more. For those looking for a low carb option, a low carb meal contains 40g or less carbs per serve and a snack contains 15g or less carbs per serve.</p>
                <p><button ng-click="show_carbs=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>
              </div>
            </div>
          </td>
        </tr>
        <tr ng-show="$ctrl.data['highFibre?']">
          <td colspan="2">
            <a href="#" ng-click="show_fibre = !show_fibre">
              High in Fibre
              <span class="float-right">
                <i class="fa" ng-class="{ 'fa-angle-up': show_fibre, 'fa-angle-down': !show_fibre }"></i>
              </span>
            </a>
            <div
              class="mt-2"
              ng-show="show_fibre">
              <div class="details">
                <p><em>Fibre is what keeps our guts happy.</em></p>
                <p>Fibre is essential to good gut health. It is what all the bacteria in your gut feasts on to help keep your bowel in good shape. Ladies should be aiming for 25g fibre per day and blokes should be going for 30g.</p>
                <p>A high fibre meal contains 6g or more fibre per serve. A high fibre snack has 3g or more fibre.</p>
                <p><button ng-click="show_fibre=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>
              </div>
            </div>
          </td>
        </tr>
        <tr ng-show="$ctrl.data['lowFat?']">
          <td colspan="2">
            <a href="#" ng-click="show_fat = !show_fat">
              Low in Fat
              <span class="float-right">
                <i class="fa" ng-class="{ 'fa-angle-up': low_fat, 'fa-angle-down': !low_fat }"></i>
              </span>
            </a>
            <div
              class="mt-2"
              ng-show="show_fat">
              <div class="details">
                <p><em>Fat is the most concentrated energy source in our diet.</em></p>
                <p>There are three different types of fat- mono-unsaturated, poly-unsaturated and saturated. The unsaturated fat is actually great for our bodies (in small amounts) and helps to protect against elevated cholesterol and other lifestyle diseases. Saturated fat, on the other hand, is the stuff that helps increase our risk of developing all of these lifestyle diseases. Fat is the last source of energy that our bodies tap into after carbohydrate and protein, so eating foods that are high in fat helps us add to the collection of fat already in our bodies that we need to burn. From a heart health and a weight management perspective, try to limit fat intake to no more than 70g per day.</p>
                <p>A meal that is low in fat contains less than 10g fat per serve and a low fat snack contains less than 3g fat per serve.</p>
                <p><button ng-click="show_fat=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>
              </div>
            </div>
          </td>
        </tr>
        <tr ng-show="$ctrl.data['lowSodium?']">
          <td colspan="2">
            <a href="#" ng-click="show_sodium = !show_sodium">
              Low in Sodium
              <span class="float-right">
                <i class="fa" ng-class="{ 'fa-angle-up': low_sodium, 'fa-angle-down': !low_sodium }"></i>
              </span>
            </a>
            <div
              class="mt-2"
              ng-show="show_sodium">
              <div class="details">
                <p><em>Too much sodium can lead to high blood pressure.</em></p>
                <p>The most common source of sodium in our diet is from salt, whether it be added at the table, during the cooking process or even in the manufacturing stage. Research has shown that as our intake of sodium increases, so too does our risk of developing high blood pressure and other heart related diseases. Often salt is found in foods that you would never imagine were salty such as bread, breakfast cereals and some meats. When looking for a low salt product aim for less than 500mg per serve for a meal and 200mg or less for a snack. Try to limit your daily sodium intake to 2300mg.</p>
                <p><button ng-click="show_sodium=false" type="button" class="btn btn-pill btn-sm btn-primary">Close</button></p>
              </div>
            </div>
          </td>
        </tr>
        <tr ng-show="$ctrl.data['lactoseFree?']">
          <td colspan="2" class="text-green-dark">
            Lactose Free
          </td>
        </tr>
        <tr ng-show="$ctrl.data['glutenFree?']">
          <td colspan="2" class="text-green-dark">
            Gluten Free
          </td>
        </tr>
      </table>
      <p class="small text-gray mb-0">
        Nutritional information provided on Voome is taken from sources provided by
        third parties, including the Food Standards Australia New Zealand (FSANZ)
        NUTTAB 2010 guide to nutrient content. Refer to site
        <a href="https://voome.com.au/terms">Terms &amp; Conditions</a>
        for further information.
      </p>
    </div>`,

  controller() {
    return {
      $onInit() {
        this.mode = `per_serve`;
      },

      calculatePerServe(value, serves) {
        return value * 1 / serves;
      },

      calculatePerGrams(value, weight) {
        return value * 100 / weight;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Nutrition/NutritionInformation.js